// CesiumConfig.js
// Store Cesium Ion access token here for import

export const CESIUM_ION_ACCESS_TOKEN = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiJlYjFlYzJmYi0yZTk2LTRjYzktYWFlZC03MzQzOWZlODZmYWUiLCJpZCI6MzA5MTEyLCJpYXQiOjE3NDkyMjg0MzZ9.ByifooM_ov2NFtv3yBEDjRdQOGTfc47Qr5aqjJ41_yA";
